<!--TODO: Make left nav float-->
<template>
  <b-container fluid="sm">
    <b-row class="text-left">
      <b-col cols="2">
        <div class="sidebar">
          <b-card>
            <b-nav vertical>
              <b-nav-item @click="goto('fear')">Fearing Death</b-nav-item>
              <b-nav-item @click="goto('immortality')">Immortality</b-nav-item>
              <b-nav-item @click="goto('purpose')">Purpose</b-nav-item>
              <!--          <b-nav-item @click="goto('senescence')">Senescence.info</b-nav-item>-->
            </b-nav>
          </b-card>
        </div>
      </b-col>
      <b-col>
        <div class="maglabquote">
          <b-card class="text-center">

            <p>"The meaningless absurdity of life is the only incontestable knowledge accessible to man."</p>
            <footer class="blockquote-footer">
              Leo Tulsoy
            </footer>

          </b-card>
        </div>
        <br>
        <div ref="fear" class="div">
          <h2>Fearing Death and Curing Aging</h2>
          <blockquote><p align="justify">You are going to die. It may take some time, but not too long since most people
            do not live to be 100 and very few live more than 110 years. You, like everyone else, suffer from aging and
            most likely it will kill you. Death and eternal darkness are inevitable. Think about it for a second...</p>

            <p align="justify"><em>Keywords:</em> anti-aging, biogerontology, dying, immortalist, life-extension,
              mortality, rejuvenation</p></blockquote>

          <!--          <p><IMG src="cross.gif" width="860" height="27" alt="Death is the ultimate prison"></p>-->
          <p align="justify">To say I am afraid to die is an understatement; I am absolutely terrified of death, and I'm
            not embarrassed at all to admit it. The way I am unable to conceive the nothingness that happens after death
            is dreadful. Death is eternal oblivion, an everlasting prison. I am an <a
                href="http://jp.senescence.info/thoughts/index.html">atheist</a>, which means I don't have religion to
            give me hope--and doesn't hope derive from a fear to face reality? Isn't religion a delusion to avoid the
            harsh realities of our chaotic existence and of death in particular? As far as I can tell, my death is the
            end of the world.</p>

          <p align="justify">Back in elementary school, I realized we all have a genetic, lethal disease called aging. I
            remember being frightened that my mother would die and terrified that my existence was ephemeral and
            meaningless. At the time, it felt like I was being told I had terminal cancer or some other horrible
            disease. Death was inevitable. No matter how rich or successful I could be in life, it would all be lost in
            the end. So, still a child, I found an objective, a purpose for my life: to cure human aging.</p>

          <p align="justify">I want to conquer aging because aging is, and will be, the major cause of suffering and
            death among the ones I love. I want to end aging to safeguard the future because I want to choose my future
            instead of being ruled by this debilitating disease. I want to cure aging because otherwise I will die.
            Eradicating death must be our purpose. I don't know if I will succeed, but I know I will not quit since to
            quit is to die.</p>
          <div class='maglabquote'>
            <b-card class="text-center">

              <p>Death is an imposition on the human race, and no longer acceptable."</p>
              <footer class="blockquote-footer">
                Alan Harrington
              </footer>

            </b-card>
          </div>
        </div>
        <br>
        <div ref='immortality'>
          <h2>Immortality</h2>
          <p align="justify">Assuming you are lucky enough to live a long life and suffer from aging, chances are your
            future will entail significant pain, frailty and diseases. Chief among concerns of elderly adults are
            cognitive aging and neurodegenerative diseases: forgetting your children's names and ultimately losing
            oneself. However, if we make an effort to cure aging our future becomes one of unknown paths. Who knows? Our
            future might involve a holiday on Mars in the year 3000. I want to be a part of the future and not merely a
            road to it.</p>

          <p align="justify">I aim for immortality, literally, not metaphorically speaking. Yes, really: physical
            immortality. I don't claim it will be easy or even possible. All I claim is that I will try. The first, most
            prominent obstacle to achieve immortality is aging, and so I chose an <a
                href="http://pcwww.liv.ac.uk/~aging/">academic career as a gerontologist</a>. I hope my work and ideas
            can be useful for the understanding and control of human aging. As <router-link to="/future-grandparents">discussed
              elsewhere</router-link>, curing aging is a daunting but not impossible task.</P>
          <div class="maglabquote">
            <b-card class=text-center>

              <p>Obstacles are those frightful things you see when you take your eyes off your goal."</p>
              <footer class="blockquote-footer">
                Henry Ford
              </footer>

            </b-card>
          </div>
        </div>
        <div ref="purpose">
          <h2>Purpose</h2>
          <br>
          <p align="justify">Back in 1997 I started <strong>senescence.info</strong> as a way of showing my commitment
            and dedication to life, to eternal life. With time, ironically the driving force of the enemy I want to
            conquer, <strong>senescence.info</strong> has become a portal for aging research with <router-link
                to="/gerontology-tutorials">tutorials</router-link> mixed with deeper sociological and <router-link
                to="/gerontology">scientific essays</router-link>. So please read on and do not be more afraid of life than
            of death.</P>

          <p align="justify">I hope <strong>senescence.info</strong> can also make people aware of the problem that is
            aging. Aging will likely kill you and those you love. It is the main reason why great artists, scientists,
            sportsmen, and thinkers die. Our society and religion make it easier to accept aging and the inevitability
            of death. I believe that if people thought more about death and how horrible it is, a greater effort would
            be made to avoid death and invest more in biomedical research and in understanding aging in particular.</P>

          <p align="justify">Aging is also becoming a worldwide social and economic problem (<a
              href="http://social.un.org/index/Ageing.aspx">UN Programme on Ageing</a>). Even so, few resources are
            aimed at studying and tinkering with the aging process and most people are not even aware that research is
            done on the biology of aging. Much more money is spent to fight specific age-related diseases than to fight
            the aging process. Less than 20% of the US National Institute on Aging's budget goes to research the basic
            causes of aging, which pales in comparison with the resources available to other medical problems like
            neurodegenerative diseases and cancer (Adelman, 1998; Warner, 2001; Miller, 2005). (This is not to say
            funding for specific diseases is not important, but merely to point out that research on aging is severely
            underfunded and unappreciated.) Sadly, the funds spent on developing ways to kill people (i.e. the military)
            are vastly superior to the funds spent on making people live longer. Hopefully,
            <strong>senescence.info</strong> can contribute to make the public aware of the work done on aging and its
            importance.</p>

          <p align="justify">I've been asked before: Why prolong life? I can give a million reasons but I think my
            highest objective is to discover the secrets of this infinite universe. Perhaps it's a dream, but the future
            is made of dreams, and I believe in the beauty of my dreams.</p>
          <div class="maglabquote">
            <b-card class="text-center">
              <p>"There are three requisites for growth without bound, and only three: the will
                to remake oneself; the genius to survive; and the strength to suffer."</p>
              <footer class="blockquote-footer">
                David Zindell
              </footer>

            </b-card>
          </div>
          <br>
        </div>


        <div align="center"><p><img alt="May dreams become the future" border="1" height="333"
                                    src="../assets/vision.jpg" width="393"></p>
          <p>May dreams become the future</P></div>

        <hr>


      </b-col>
    </b-row>


  </b-container>

</template>


<script>
export default {
  name: 'DeathFears',
  methods: {
    goto(refName) {
      var element = this.$refs[refName];
      var top = element.offsetTop;

      window.scrollTo(0, top);
    }
  }
};
</script>


<style>
h2 {
  padding-top: 30px;
}

.sidebar {
  position: -webkit-sticky;
  position: sticky;
  top: 3%;
}

</style>




// WEBPACK FOOTER //
// src/components/DeathFears.vue